import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "./assets/Burakyol-logo.jpeg";

const Contact = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        company: "",
        subject: "",
        message: ""
    });
    const [formStatus, setFormStatus] = useState(null);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Form gönderme işlemi burada yapılacak
        setFormStatus("success");
        setTimeout(() => {
            setFormStatus(null);
            setFormData({
                name: "",
                email: "",
                phone: "",
                company: "",
                subject: "",
                message: ""
            });
        }, 3000);
    };

    const contactInfo = [
        {
            icon: (
                <svg className="w-full h-full" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
            ),
            title: "Adres",
            content: "Emirhan cad. Bayındır sok. Uygar apt. No:1/3 Beşiktaş/İstanbul"
        },
        {
            icon: (
                <svg className="w-full h-full" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
            ),
            title: "Telefon",
            content: "+90 (212) 512 99 21"
        },
        {
            icon: (
                <svg className="w-full h-full" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
            ),
            title: "E-posta",
            content: "info@burakyolmuhendislik.com"
        },
        {
            icon: (
                <svg className="w-full h-full" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            ),
            title: "Çalışma Saatleri",
            content: "Pazartesi - Cuma: 09:00 - 17:30"
        }
    ];

    return (
        <div className="min-h-screen bg-white">
            {/* Logo */}
            <div className="hidden xl:block absolute left-[15vw] 2xl:left-[22vw] 3xl:left-[28rem] top-[60px] -translate-y-1/2 z-40 pointer-events-auto w-[80px] h-[80px] 2xl:w-[90px] 2xl:h-[90px] 3xl:w-[100px] 3xl:h-[100px] rounded-full flex items-center justify-center shrink-0 overflow-hidden shadow-xl">
                <img src={logo} alt="Logo" className="w-full h-full object-cover" />
            </div>
        
            {/* Navbar */}
            <header className="fixed top-[12px] md:top-[24px] left-0 right-0 z-50 flex items-center justify-center px-4 md:px-sm w-full pointer-events-none">
                <div className="pointer-events-auto w-full max-w-[700px] h-[60px] md:h-[72px] flex items-center justify-between bg-[#01346b] backdrop-blur-xl rounded-full px-4 md:px-xs py-xs shadow-xl border border-white/10">
                    <div className="flex items-center gap-4 pl-2 md:pl-xs">
                        <div className="md:hidden w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                            <img src={logo} alt="Logo" className="w-full h-full object-cover" />
                        </div>
                        
                        <nav className="hidden md:flex items-center gap-6 pl-4">
                            <Link to="/hakkimizda" className="font-label text-label text-page-bg/80 hover:text-page-bg transition-colors duration-300">Hakkımızda</Link>
                            <Link to="/projeler" className="font-label text-label text-page-bg/80 hover:text-page-bg transition-colors duration-300">Projeler</Link>
                            <Link to="/hizmetler" className="font-label text-label text-page-bg/80 hover:text-page-bg transition-colors duration-300">Hizmetler</Link>
                            <Link to="/iletisim" className="font-label text-label text-page-bg hover:text-page-bg transition-colors duration-300">İletişim</Link>
                        </nav>
                        
                        <button 
                            className="md:hidden text-white p-14"
                            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                            aria-label="Toggle menu"
                        >
                            {mobileMenuOpen ? (
                                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            ) : (
                                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                            )}
                        </button>
                    </div>
                    <Link to="/" className="bg-page-bg text-black font-label text-sm md:text-label h-full px-4 md:px-8 rounded-full hover:bg-white transition-colors duration-300 scale-95 hover:scale-100 shrink-0 flex items-center shadow-sm">
                        Anasayfa
                    </Link>
                </div>

                <div 
                    className={`md:hidden absolute top-[72px] left-4 right-4 bg-[#01346b] backdrop-blur-xl rounded-3xl shadow-2xl border border-white/10 overflow-hidden pointer-events-auto transition-all duration-500 ease-out ${
                        mobileMenuOpen 
                            ? 'opacity-100 translate-y-0 max-h-96' 
                            : 'opacity-0 -translate-y-4 max-h-0 pointer-events-none'
                    }`}
                >
                    <nav className="flex flex-col p-4">
                        <Link to="/hakkimizda" className="text-white py-4 px-4 hover:bg-white/10 rounded-xl transition-all duration-300 font-medium transform hover:translate-x-2" onClick={() => setMobileMenuOpen(false)}>Hakkımızda</Link>
                        <Link to="/projeler" className="text-white py-4 px-4 hover:bg-white/10 rounded-xl transition-all duration-300 font-medium transform hover:translate-x-2" onClick={() => setMobileMenuOpen(false)}>Projeler</Link>
                        <Link to="/hizmetler" className="text-white py-4 px-4 hover:bg-white/10 rounded-xl transition-all duration-300 font-medium transform hover:translate-x-2" onClick={() => setMobileMenuOpen(false)}>Hizmetler</Link>
                        <Link to="/iletisim" className="text-white py-4 px-4 hover:bg-white/10 rounded-xl transition-all duration-300 font-medium transform hover:translate-x-2" onClick={() => setMobileMenuOpen(false)}>İletişim</Link>
                    </nav>
                </div>
            </header>

            {/* Hero Section */}
            <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#01346b] via-[#01346b] to-[#024a8f]">
                <div className="absolute inset-0 opacity-10">
                    <div className="absolute top-20 left-20 w-72 h-72 bg-white rounded-full blur-3xl animate-pulse"></div>
                    <div className="absolute bottom-20 right-20 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
                </div>

                <div className="absolute inset-0 opacity-5" style={{
                    backgroundImage: 'linear-gradient(white 1px, transparent 1px), linear-gradient(90deg, white 1px, transparent 1px)',
                    backgroundSize: '50px 50px'
                }}></div>

                <div className="max-w-[1200px] mx-auto px-4 md:px-8 relative z-10 text-center py-24 md:py-32">
                    <div className="inline-flex items-center gap-2 px-4 md:px-6 py-2 md:py-3 bg-white/20 backdrop-blur-md rounded-full mb-6 md:mb-8 animate-fade-in-down">
                        <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                        <span className="text-white text-xs md:text-sm font-semibold tracking-wider">BİZE ULAŞIN</span>
                    </div>
                    
                    <h1 className="font-display text-3xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-4 md:mb-6 leading-tight animate-fade-in" style={{ animationDelay: '0.2s' }}>
                        Size Nasıl<br />
                        <span className="bg-gradient-to-r from-white to-white/80 bg-clip-text text-transparent">Yardımcı Olabiliriz?</span>
                    </h1>
                    
                    <p className="text-base md:text-lg lg:text-xl text-white/90 max-w-3xl mx-auto leading-relaxed animate-fade-in px-4" style={{ animationDelay: '0.4s' }}>
                        Projeleriniz ve sorularınız için bizimle iletişime geçin. Uzman ekibimiz size en kısa sürede dönüş yapacaktır.
                    </p>

                    {/* Scroll Indicator */}
                    <div className="animate-bounce mt-12 md:mt-16">
                        <svg className="w-6 h-6 text-white/70 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                        </svg>
                    </div>
                </div>
            </section>

            {/* Contact Section */}
            <section className="py-16 md:py-20 lg:py-32 bg-white">
                <div className="max-w-[1400px] mx-auto px-4 md:px-8">
                    <div className="grid lg:grid-cols-2 gap-8 md:gap-12 lg:gap-16">
                        {/* Contact Form */}
                        <div className="order-2 lg:order-1">
                            <div className="mb-6 md:mb-8">
                                <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
                                    Bize Mesaj Gönderin
                                </h2>
                                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                                    Aşağıdaki formu doldurarak bize ulaşabilirsiniz. En kısa sürede size geri dönüş yapacağız.
                                </p>
                            </div>

                            <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6">
                                <div className="grid md:grid-cols-2 gap-4 md:gap-6">
                                    <div>
                                        <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2">
                                            Ad Soyad *
                                        </label>
                                        <input
                                            type="text"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                            className="w-full px-3 md:px-4 py-2.5 md:py-3 text-sm md:text-base border-2 border-gray-200 rounded-xl focus:border-[#01346b] focus:outline-none transition-colors duration-300"
                                            placeholder="Adınız Soyadınız"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2">
                                            E-posta *
                                        </label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                            className="w-full px-3 md:px-4 py-2.5 md:py-3 text-sm md:text-base border-2 border-gray-200 rounded-xl focus:border-[#01346b] focus:outline-none transition-colors duration-300"
                                            placeholder="ornek@email.com"
                                        />
                                    </div>
                                </div>

                                <div className="grid md:grid-cols-2 gap-4 md:gap-6">
                                    <div>
                                        <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2">
                                            Telefon
                                        </label>
                                        <input
                                            type="tel"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            className="w-full px-3 md:px-4 py-2.5 md:py-3 text-sm md:text-base border-2 border-gray-200 rounded-xl focus:border-[#01346b] focus:outline-none transition-colors duration-300"
                                            placeholder="+90 (555) 555 55 55"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2">
                                            Şirket
                                        </label>
                                        <input
                                            type="text"
                                            name="company"
                                            value={formData.company}
                                            onChange={handleChange}
                                            className="w-full px-3 md:px-4 py-2.5 md:py-3 text-sm md:text-base border-2 border-gray-200 rounded-xl focus:border-[#01346b] focus:outline-none transition-colors duration-300"
                                            placeholder="Şirket Adı"
                                        />
                                    </div>
                                </div>

                                <div>
                                    <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2">
                                        Konu *
                                    </label>
                                    <input
                                        type="text"
                                        name="subject"
                                        value={formData.subject}
                                        onChange={handleChange}
                                        required
                                        className="w-full px-3 md:px-4 py-2.5 md:py-3 text-sm md:text-base border-2 border-gray-200 rounded-xl focus:border-[#01346b] focus:outline-none transition-colors duration-300"
                                        placeholder="Mesaj Konusu"
                                    />
                                </div>

                                <div>
                                    <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2">
                                        Mesajınız *
                                    </label>
                                    <textarea
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                        rows={5}
                                        className="w-full px-3 md:px-4 py-2.5 md:py-3 text-sm md:text-base border-2 border-gray-200 rounded-xl focus:border-[#01346b] focus:outline-none transition-colors duration-300 resize-none"
                                        placeholder="Mesajınızı buraya yazın..."
                                    ></textarea>
                                </div>

                                <button
                                    type="submit"
                                    className="w-full bg-gradient-to-r from-[#01346b] to-[#024a8f] text-white py-3 md:py-4 rounded-xl text-sm md:text-base font-bold hover:shadow-xl transition-all duration-300 hover:scale-[1.02] flex items-center justify-center gap-2"
                                >
                                    <span>Mesaj Gönder</span>
                                    <svg className="w-4 h-4 md:w-5 md:h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                                    </svg>
                                </button>

                                {formStatus === "success" && (
                                    <div className="p-3 md:p-4 bg-green-50 border-2 border-green-500 rounded-xl text-green-700 text-sm md:text-base font-medium text-center animate-fade-in">
                                        Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız.
                                    </div>
                                )}
                            </form>
                        </div>

                        {/* Contact Info */}
                        <div className="order-1 lg:order-2">
                            <div className="mb-6 md:mb-8">
                                <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
                                    İletişim Bilgileri
                                </h2>
                                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                                    Ofisimizi ziyaret edebilir veya aşağıdaki iletişim kanallarından bizimle görüşebilirsiniz.
                                </p>
                            </div>

                            <div className="space-y-4 md:space-y-6">
                                {contactInfo.map((info, idx) => (
                                    <div 
                                        key={idx}
                                        className="group bg-gradient-to-br from-gray-50 to-white rounded-2xl md:rounded-3xl p-4 md:p-6 border border-gray-100 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
                                    >
                                        <div className="flex items-start gap-3 md:gap-4">
                                            <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-[#01346b] to-[#024a8f] rounded-xl md:rounded-2xl flex items-center justify-center text-white flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                                                <div className="w-6 h-6 md:w-8 md:h-8">
                                                    {info.icon}
                                                </div>
                                            </div>
                                            <div className="flex-1 min-w-0">
                                                <h3 className="font-display text-base md:text-lg lg:text-xl font-bold text-gray-900 mb-1 md:mb-2">
                                                    {info.title}
                                                </h3>
                                                <p className="text-xs md:text-sm lg:text-base text-gray-600 leading-relaxed whitespace-pre-line break-words">
                                                    {info.content}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Map */}
                            <div className="mt-6 md:mt-8 rounded-2xl md:rounded-3xl overflow-hidden shadow-lg h-56 md:h-64 lg:h-80 bg-gray-200 border border-gray-100">
                                <iframe
                                    title="Burakyol Mühendislik Lokasyon"
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3008.3872935842717!2d29.00667431539784!3d41.04546237929712!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab7650656bd63%3A0x8e54a6d3c9c0a48e!2sEmirhan%20Cd.%2C%20Be%C5%9Fikta%C5%9F%2F%C4%B0stanbul!5e0!3m2!1str!2str!4v1234567890123!5m2!1str!2str"
                                    width="100%"
                                    height="100%"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="py-16 md:py-20 lg:py-32 bg-gradient-to-br from-[#01346b] via-[#01346b] to-[#024a8f] relative overflow-hidden">
                <div className="absolute inset-0 opacity-10">
                    <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
                    <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
                </div>

                <div className="max-w-[1200px] mx-auto px-4 md:px-8 text-center relative z-10">
                    <h2 className="font-display text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-white mb-4 md:mb-6 px-4">
                        Projelerimizi İncelemek İster misiniz?
                    </h2>
                    <p className="text-sm md:text-base lg:text-lg xl:text-xl text-white/90 mb-8 md:mb-10 max-w-2xl mx-auto px-4">
                        Tamamladığımız ve devam eden projelerimize göz atın, referanslarımızı inceleyin.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center px-4">
                        <Link to="/projeler" className="px-6 md:px-8 py-3 md:py-4 bg-white text-[#01346b] rounded-full text-sm md:text-base font-bold hover:bg-gray-100 transition-all duration-300 shadow-xl hover:scale-105 flex items-center justify-center gap-2">
                            <span>Projeleri Gör</span>
                            <svg className="w-4 h-4 md:w-5 md:h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                            </svg>
                        </Link>
                        <Link to="/hizmetler" className="px-6 md:px-8 py-3 md:py-4 bg-white/10 backdrop-blur-md text-white border-2 border-white/30 rounded-full text-sm md:text-base font-bold hover:bg-white/20 transition-all duration-300 flex items-center justify-center gap-2">
                            <span>Hizmetlerimiz</span>
                        </Link>
                    </div>
                </div>
            </section>

            <style jsx>{`
                @keyframes fade-in-down {
                    from {
                        opacity: 0;
                        transform: translateY(-20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @keyframes fade-in {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                .animate-fade-in-down {
                    animation: fade-in-down 0.6s ease-out;
                }

                .animate-fade-in {
                    animation: fade-in 0.6s ease-out;
                }
            `}</style>
        </div>
    );
};

export default Contact;
